const openColorsSettings = () => {
  window.open("/account_settings/general", "_blank")
}

export { openColorsSettings }
